import { typeDisscount } from '../constants/options.constant';

export const priceHandle = (mechanic, priceWithPercentage, priceStatic) => {
	if (mechanic === typeDisscount.percentage) {
		return priceWithPercentage;
	}
	if (mechanic === typeDisscount.permanent) {
		return priceStatic;
	}
	return null;
};
